import { render, staticRenderFns } from "./SfCallToAction.vue?vue&type=template&id=6962d423"
import script from "./SfCallToAction.vue?vue&type=script&lang=js"
export * from "./SfCallToAction.vue?vue&type=script&lang=js"
import style0 from "./SfCallToAction.vue?vue&type=style&index=0&id=6962d423&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports